module.exports = __webpack_public_path__ + "static/image/font/pc/bmyeonsung-4@3x.jpg?60076406";